import baseController from 'netxcore@netx/core-cms/controller';
import {appViews} from '@netx/core-app/singletons/appViews';
import {session} from '@netx/core-auth/collections/singleton/session';
import categoryConfig from '@netx/core-category/config';
import CategoryModel from '@netx/core-category/models/category';
import CMSActionCollection from '@netx/core-cms/collections/CMSActions';
import CMSMenuCollection from '@netx/core-cms/collections/CMSMenus';
import CMSPageCollection from '@netx/core-cms/collections/CMSPages';
import CMSMenuModel from '@netx/core-cms/models/CMSMenu';
import {dispatcher} from '@netx/core-next/instance/dispatcher';
import {getPrefixedLogger} from '@netx/core-next/instance/logger';
import {appRouter} from '@netx/core-next/instance/router';
import {isMobile} from '@netx/core-next/utils/browser';
import Netx from '@netx/core/bootstrap';
import {i18n} from '@netx/core/i18n';
import {FindLegacyAction} from '@netx/core/legacyActionManager';
import {Menus} from '@netx/core/legacyMenuManager';
import {randomChars} from '@netx/core/utils/randomChars';
import cmsConfig from './config';
import CMSPageModel from './models/CMSPage';
import {
	currentPortal,
	currentPortalActions,
	currentPortalMenus,
	currentPortalPage,
	currentPortalPages,
} from './singletons';

export {default} from 'netxcore@netx/core-cms/controller';

const logger = getPrefixedLogger('cms/controller');

/**
 * Init handler
 * overriding to cut out
 * @event module:cms#cms:init
 * @param {object} options
 */
dispatcher.off('cms:init');
dispatcher.once('cms:init', function (options) {
	// MODULE ROUTES
	// =============
	// Setup all module specific routes.  If the module is
	// available and initialized these routes are available application wide.

	options = {...options};

	Netx.cms = Netx.cms || {};
	Netx.cms.currentPage = currentPortalPage;
	Netx.cms.portal = currentPortal;
	Netx.cms.pages = currentPortalPages;

	// should listen for page data before loading initial hash
	// wait until the pages are loaded in case we are starting on a page
	dispatcher.once('cms:pages:loaded', function () {
		// and load the initial url
		Backbone.history.loadUrl();
	});

	dispatcher.on('cms:route:category:root', function () {
		appRouter.navigate('category/' + categoryConfig.categoryid, {
			trigger: true,
		});
	});

	/***************
	 * CMS Pages
	 **************/

	/**
	 * Load this portal's pages, if not yet loaded
	 */
	dispatcher.on('cms:pages:init', function (portalId) {
		if (portalId && currentPortalPages.portalId != portalId) {
			currentPortalPages.fetchPortal(portalId);
		}
		dispatcher.trigger('cms:actions:init', portalId);
	});

	/**
	 * @event module:cms#cms:page:route
	 * @param {string} pageName Page name
	 * @fires module:cms#cms:page
	 */
	dispatcher.off('cms:page:route');
	dispatcher.on('cms:page:route', function (pageName) {
		if (_.isUndefined(pageName)) {
			console.warn(
				'A page route was attempted but the page name was not provided.',
			);
			return;
		}
		// THEM-1329 - scroll to the top on a new page
		$('#site').scrollTop(0);

		dispatcher.trigger('cms:page', pageName);
	});
	/**
	 * @event module:cms#cms:page
	 * @param {string} pageName Page name
	 * @fires module:cms#cms:page:show
	 */
	dispatcher.off('cms:page');
	dispatcher.on('cms:page', function (pageName) {
		const pathArr = pageName.split('/');
		pageName = pathArr[pathArr.length - 1];

		const chapterName = pathArr.length > 1 ? pathArr[pathArr.length - 2] : null;

		const action = FindLegacyAction('cms:page:' + pageName + ':route');
		const safeName = pageName.replace(/\//g, '-');
		const template = 'page-' + safeName;

		var pageModel = currentPortalPages.findWhere({slug: pageName});
		if (!pageModel) {
			logger.warn('cms:page >', `no page found for route >`, pageName);
			return;
		}

		// not parsing blocks till route, will only parse once
		// pageModel.setBlocks();
		pageModel.parseBlocks();

		// Show
		dispatcher.trigger(
			'cms:page:show',
			_.extend(
				{
					className: 'page ' + pageModel.get('template'),
					id: template,
					model: pageModel,
					collection: pageModel.get('blocks'),
					removeOnHide: true,
				},
				action && action.viewOpts ? action.viewOpts : {},
			),
		);

		chapterName
			? dispatcher.trigger('cms:subnav:update', chapterName)
			: dispatcher.trigger('cms:subnav:hide');

		dispatcher.trigger('cms:page:routed', pageName);
	});

	/**
	 * Load this portal's actions, if not yet loaded.
	 */
	dispatcher.on('cms:actions:init', function (portalId) {
		if (portalId && currentPortalActions.portalId != portalId) {
			currentPortalActions.fetchPortal(portalId);
			dispatcher.trigger('cms:init:template');
		}
	});

	dispatcher.trigger('cms:extend', Netx.cms);
	dispatcher.trigger('cms:portal:returned', currentPortal);
	dispatcher.trigger('cms:initialized', Netx.cms);
});

dispatcher.once('cms:extend', function (options) {
	$('html').addClass('theme-clean');

	// the router triggers cms:page before pages are loaded
	// if that happens, listen to cms:pages:loaded and try again
	dispatcher.on('cms:page', function (pageName) {
		Netx.cms.pageName = pageName;
		dispatcher.once('cms:pages:loaded', function () {
			dispatcher.trigger('cms:page', Netx.cms.pageName);
		});
	});

	/**
	 * @event module:cms#cms:page:show
	 * @param {object} viewOptions View options
	 */
	dispatcher.off('cms:page:show');
	dispatcher.on(
		'cms:page:show',
		function (viewOptions) {
			viewOptions = viewOptions || {};
			viewOptions.id = 'cms-page-view';
			// piggy-back on the post-login-app chunk
			import(
				/* webpackChunkName: "post-login-app" */ './views/CMSPageView'
			).then((View) => {
				appViews.add({
					viewClass: View.default,
					showActions: ['cms:page:show'],
					viewOptions: viewOptions,
				});
			});
		},
		window,
	);

	dispatcher.on('cms:portal:unloadFont', function (portal) {
		// set everything to use system fonts

		var style = document.createElement('style');
		style.type = 'text/css';
		style.id = 'system-fonts';
		style.innerHTML =
			'body, h1, h2, h3, h4, h5, #passive-alert .alert .container p { font-family: "system"; }';
		document.getElementsByTagName('head')[0].appendChild(style);
	});

	dispatcher.on('cms:portal:loadFont', function (portal) {
		// currently just works for one font, main font defaults to SourceSansPro regular
		if (portal.get('font') > 0) {
			var fontUrl =
					'/theme/' + portal.get('path') + '/font?no_cache' + randomChars(8),
				fontModel = portal.get('fontModel'),
				fontFormat = '';

			if (fontModel && fontModel.get('assetId')) {
				switch (fontModel.get('filetypelabel')) {
					case 'ttf':
						fontFormat = 'truetype';
						break;
					case 'eot':
						fontFormat = 'embedded-opentype';
						break;
					case 'otf':
						fontFormat = 'truetype';
						break;
					// case 'woff':
					// case 'woff2':
					// case 'svg':
					default:
						fontFormat = fontModel.get('filetypelabel');
						break;
				}
			}

			// replace the style block if it exists
			$('#cms-font').remove();

			var style = document.createElement('style');
			style.type = 'text/css';
			style.id = 'cms-font';

			// THEM-1398 - if we don't have the asset bean yet (login pages),
			// don't put in a blank fontFormat or Firefox will get confused
			if (fontFormat) {
				style.innerHTML =
					"<style>@font-face { font-family: 'themeFontBold'; src: url('" +
					fontUrl +
					"') format('" +
					fontFormat +
					"'); font-style: normal; font-weight: bold; } @font-face { font-family: 'themeFontSemibold'; src: url('" +
					fontUrl +
					"') format('" +
					fontFormat +
					"'); font-style: normal; font-weight: 600; } @font-face { font-family: 'themeFontRegular'; src: url('" +
					fontUrl +
					"') format('" +
					fontFormat +
					"'); font-style: normal; font-weight: normal; }	@font-face { font-family: 'themeFontLight'; src: url('" +
					fontUrl +
					"') format('" +
					fontFormat +
					"'); font-style: normal; font-weight: normal; } </style>";
			} else {
				style.innerHTML =
					"<style>@font-face { font-family: 'themeFontBold'; src: url('" +
					fontUrl +
					"'); font-style: normal; font-weight: bold; } @font-face { font-family: 'themeFontSemibold'; src: url('" +
					fontUrl +
					"'); font-style: normal; font-weight: 600; } @font-face { font-family: 'themeFontRegular'; src: url('" +
					fontUrl +
					"'); font-style: normal; font-weight: normal; }	@font-face { font-family: 'themeFontLight'; src: url('" +
					fontUrl +
					"'); font-style: normal; font-weight: normal; } </style>";
			}

			document.getElementsByTagName('head')[0].appendChild(style);
		}
	});

	dispatcher.on('cms:portal:loadColors', function (prime, primeAlt) {
		if (!prime) logger.warn('primary color not set');

		primeAlt = currentPortal.parseAltColor();

		// todo: use css custom properties for everything
		document
			.getElementsByTagName('html')[0]
			.style.setProperty('--mdc-portal-primary', prime);
		document
			.getElementsByTagName('html')[0]
			.style.setProperty('--mdc-portal-on-primary', primeAlt);

		const style = document.createElement('style');
		style.type = 'text/css';
		style.id = 'cms-color';
		style.innerHTML = '';

		style.innerHTML +=
			'.theme-clean .primary-background { background-color: ' +
			prime +
			'!important; }';
		style.innerHTML +=
			'.theme-clean .CartBar-root { background: ' + prime + '!important; }';
		style.innerHTML += '.primary-color { color: ' + prime + '!important; }';
		style.innerHTML +=
			'.primary-color-hover:hover, .primary-color-nested-hover:hover .primary-color-nested { color: ' +
			prime +
			'!important; }';
		style.innerHTML +=
			'.primary-border { border-color: ' + prime + '!important; }';
		style.innerHTML +=
			'[data-nx-control="crumbs"] .primary-border:before, [data-nx-control="crumbs"] .primary-border:after { border-color: transparent transparent transparent ' +
			prime +
			'!important; }';
		style.innerHTML +=
			'.primary-border-hover:hover { border-color: ' + prime + '!important; }';

		style.innerHTML +=
			'.touch .primary-color-hover:hover { color: ' +
			prime +
			'!important; background-color: white!important; }';

		// specific hovers
		style.innerHTML +=
			'#asset-details .preview-wrapper .pager button:hover, #mobile-category-tree ul.categories li:hover, #category-tree ul.categories li:hover, #category .container #category-list .categories .category:hover .category-details, .nav-tabs > li.active > a, .bootstrap-select.btn-group .dropdown-toggle .filter-option:hover { color: ' +
			prime +
			'!important; }';
		// specific backgrounds
		style.innerHTML +=
			'.btn-primary, .primary-background-hover:hover, .btn-send, .btn-save, .inner-check, input[type="checkbox"]:not(.switch):not(.icon):checked ~ label::before { background-color: ' +
			prime +
			'!important; }'; //, [data-nx-pager] > div [data-nx-page].active
		// specific borders
		style.innerHTML +=
			'.inner-square, .nav-tabs > li.active > a, input[type="checkbox"]:not(.switch):not(.icon):checked ~ label::before { border-color: ' +
			prime +
			'!important; }';
		// specific triangle borders
		style.innerHTML +=
			'.asset.netx-drag-select-selected .thumbnail::before, .asset.in-cart .thumbnail::before, .block-asset.in-cart .block-size-container::before { border-color: transparent ' +
			prime +
			' transparent transparent!important; }';

		// dark
		style.innerHTML +=
			'.theme-clean .asset .thumbnail .actions [data-action]:not(button):not(.btn):hover:not(.disabled):not([disabled]):not(.active), #cms-page-detail-view .asset .thumbnail .actions [data-action]:not(button):not(.btn):hover:not(.disabled):not([disabled]):not(.active), .theme-clean .asset .thumbnail .actions .action:not(button):not(.btn):hover:not(.disabled):not([disabled]):not(.active), #cms-page-detail-view .asset .thumbnail .actions .action:not(button):not(.btn):hover:not(.disabled):not([disabled]):not(.active), .primary-alt, .primary-alt-hover:hover { color: ' +
			primeAlt +
			'!important; }';
		style.innerHTML +=
			'.primary-alt-border { border-color: ' + primeAlt + '!important; }';

		// circle loader
		style.innerHTML +=
			'@-webkit-keyframes colors { 0% { stroke: ' +
			prime +
			'; } 33% { stroke: ' +
			_.shadeColor(prime, 40) +
			'; } 66% { stroke: ' +
			prime +
			'; } 100% { stroke: ' +
			_.shadeColor(prime, -40) +
			'; } }';
		style.innerHTML +=
			'@keyframes colors         { 0% { stroke: ' +
			prime +
			'; } 33% { stroke: ' +
			_.shadeColor(prime, 40) +
			'; } 66% { stroke: ' +
			prime +
			'; } 100% { stroke: ' +
			_.shadeColor(prime, -40) +
			'; } }';

		// mobile
		style.innerHTML +=
			'.touch.theme-clean .primary-background-mobile { background-color: ' +
			prime +
			'!important; }';

		document.getElementsByTagName('head')[0].appendChild(style);
	});

	dispatcher.on('cms:portal:returned', function (portal) {
		// the portal has fetched
		// added in Clean 1.7 QA for THEM-1442
		// TODO: Remove in Clean 1.8 and replace with properly instantiated portal model
		var title = portal.get('label');
		if (title) {
			document.title = title;
		}

		dispatcher.trigger(
			'cms:portal:loadColors',
			portal.get('color1'),
			portal.get('color2'),
		);

		var link =
			document.querySelector("link[rel*='icon']") ||
			document.createElement('link');
		link.type = 'image/x-icon';
		link.rel = 'shortcut icon';
		link.href =
			'/theme/' + portal.get('path') + '/favicon?no_cache' + randomChars(8);
		document.getElementsByTagName('head')[0].appendChild(link);

		categoryConfig.categoryid = portal.get('category')
			? portal.get('category')
			: 1;

		// if this portal has a logo set, use the theme rest logo
		cmsConfig.logoUrl = '/theme/' + portal.get('path') + '/logo';
		// portal.get('logo')
		// 	? '/theme/' + portal.get('name') + '/logo'
		// 	: 'img/clean-logo.png';
		// fonts
		if (portal.get('disableWebfonts')) {
			dispatcher.trigger('cms:portal:unloadFont', portal);
		}
		if (!portal.get('disableWebfonts') && portal.get('font') > 0) {
			dispatcher.trigger('cms:portal:loadFont', portal);
		}

		if (portal.get('analytics')) {
			if (
				portal.get('googleAnalyticsEnabled') &&
				portal.get('googleAnalyticsId')
			) {
				// Load & start Analytics. core app controller already tried this but the app doesn't continue if this is called there
				dispatcher.trigger(
					'netx:analytics:start',
					'google',
					portal.get('googleAnalyticsId'),
					() => {},
				);
			}
		}

		// in case userLoginView is already visible, it will need to rerender.
		dispatcher.trigger('cms:portal:ready');
	});
});

// load all the portal submodules after the app is started
dispatcher.once('app:started', function () {
	var portal = currentPortal;

	if (!portal.get('name')) {
		console.warn('no portal');
		return;
	}

	portal
		.fetchSubModels()
		.then(
			function () {
				// nice work.
			},
			function (err) {
				dispatcher.trigger('app:alert', err);
			},
		)
		.always(function () {
			// calling this again to add the format
			if (!portal.get('disableWebfonts') && portal.get('font') > 0) {
				dispatcher.trigger('cms:portal:loadFont', portal);
			}

			if (session.authenticated() && portal.get('category')) {
				var cat = new CategoryModel({categoryid: portal.get('category')});
				cat.fetch().then(function () {
					categoryConfig.categoryid = this.get('categoryid');
					categoryConfig.categoryName = this.get('name');
				});
			}
		});

	// Not for token users
	if (!session.getToken()) {
		Netx.cms.pageNavs = currentPortalMenus;
		currentPortalMenus.fetchPortal(portal.id).then(function () {
			var mainMenu = this.find({name: 'main'});

			if (!mainMenu) {
				// portal has no menu, something is wrong
				console.warn('this portal has no menu!');
				return;
			}

			// get page navs first so we can construct slug with submenu paths
			currentPortalPages.mainMenu = mainMenu;
			currentPortalPages.fetchPortal(portal.id).then(function () {
				currentPortalActions
					.fetchPortal(portal.id, {duplicateQueryPolicy: 'merge'})
					.then(function (actionsArr) {
						// still hacking - submenu slugs
						// would be nice to get menus back from the server with all info necessary to build them
						// instead of cobbling together these three calls

						var navActions = currentPortalMenus
							.find({name: 'main'})
							.get('actions');
						_.each(navActions, function (action, idx, all) {
							// if there's an actions array and a label we have a submenu
							if (_.isObject(action) && action.actions && action.label) {
								_.each(
									action.actions,
									_.bind(
										function (a, idx, all) {
											// for each action in the submenu, add the label in the route
											var netxAction = FindLegacyAction(a);

											if (_.isUndefined(netxAction)) {
												return;
											}

											if (netxAction.route) {
												let actionRoute = netxAction.route;
												var slugArr = actionRoute.match(/page\/(.*)/);

												if (slugArr && slugArr[1] && !netxAction.changed) {
													actionRoute = 'page/' + this.label + '/' + slugArr[1];

													// this hack is in case the same page is used in multiple places
													netxAction.changed = true;
												}

												if (actionRoute.slice(0, 1) === '#') {
													actionRoute = actionRoute.slice(1);
												}

												netxAction.route = actionRoute;
											}

											// THEM-1819 - if this submenu action is a native event but there is a custom
											// label, use the custom label, not the i18n translation.
											var cmsAction = currentPortalActions.findWhere({
												event: netxAction.event,
											});
											if (cmsAction) {
												var label = cmsAction.get('label');
												if (label) {
													netxAction.label = label;
												}
											}
										},
										{
											label: action.label
												.toLowerCase()
												// convert pattersn of multiple dashes or non-word characters -> a single dash
												.replace(/[-\W]+/g, '-')
												// strip any dash from front of slug
												.replace(/^-/, '')
												// strip any dash from end of slug
												.replace(/-$/, ''),
										},
									),
								);
							} else {
								// THEM-1819 again - if this to level action is a native event but there is a custom
								// label, use the custom label, not the i18n translation.
								var netxAction = FindLegacyAction(action);
								var cmsAction = currentPortalActions.findWhere({event: action});
								if (netxAction && cmsAction) {
									var label = cmsAction.get('label');
									if (label) {
										netxAction.label = label;
									}
								}
							}
						});

						// todo: multiple menus - this collection
						Menus.cmsPageMenu = mainMenu;
						Menus.mobilePageMenu.set({
							hoistable: true,
						});
						// Menus.mobilePageMenu.attributes.actions.push(
						// 	Menus.cmsPageMenu,
						// 	'app:logout',
						// );
						Menus.headerMenu = new CMSMenuModel(Menus.cmsPageMenu.attributes);
						// do we want to keep using autotemplates?  proabably change when multiple menus are introduced

						// core-pull
						const footer = Netx.autoTemplate.views.footer;
						if (footer) {
							if (footer.menuViews) {
								footer.menuViews.headerMenu.menu = Menus.headerMenu;
							}
							footer.render();
						}

						dispatcher.trigger('cms:pages:loaded');
					});
			});
		});
	}
});
